var Theme = Theme || {};
SCM.Utilities = SCM.Utilities || {};

Theme.ArticleAbstract = (function ($) {

    return {
        init: _init
    };

    function _init() {
        initAbstractClickEvent();
    }

    function initAbstractClickEvent() {
        $('.master-main').on('click', '.js-show-abstract', handleClickEvent);
    }

    function handleClickEvent(e) {
        var $currTarget = $(e.currentTarget);
        var articleId = $currTarget.data('articleid');
        var isLayAbstract = $currTarget.data('is-lay-abstract') === 'True';
        var $abstractLocation = _getAbstractLocation(articleId, isLayAbstract);
        var $abstractLinks = $(`#abstract-${articleId}-links`);
        var isAbstractAlreadyFetchedFromServer = $currTarget.data('tried-to-fetch-abstract') === 'True';
        var ajaxUrl = _getAjaxUrl($currTarget, isLayAbstract);
        var ajaxData = {
            articleId: articleId,
            layAbstract: isLayAbstract
        };
        
        $abstractLocation.closest('.js-abstract-parent').toggleClass('abstractExpanded');


        if (!isAbstractAlreadyFetchedFromServer) {
            _fetchAbstractHtmlFromServer();
        }

        $abstractLocation.toggleClass('hide');
        _toggleAbstractAria();
        _toggleAbstractIcon();
        _toggleAriaExpanded();

        function _fetchAbstractHtmlFromServer() {
            SCM.Ajax.get(ajaxUrl, ajaxData)
                .expectActionResultModel()
                .then(_populateAbstractHtml)
                .catch(console.error)
                .finally(function () {
                    $currTarget.data('tried-to-fetch-abstract', 'True');
                });

            function _populateAbstractHtml(ajaxResponse) {
                let actionResult = ajaxResponse;
                $abstractLocation.html(actionResult.Html);
                $abstractLocation.append($abstractLinks.html());
                _handleClickEventForTabs();
                if (SCM.Utilities.Brightcove && SCM.Utilities.Brightcove.init) {
                    SCM.Utilities.Brightcove.init();
                }
                if (Theme.Utilities && Theme.Utilities.Cadmore && Theme.Utilities.Cadmore.loadCadmoreVideos) {
                    Theme.Utilities.Cadmore.loadCadmoreVideos($abstractLocation, actionResult.Data);
                }
                SCM.SiteJS.abstractMathJax();
            }
        }

        function _toggleAbstractIcon() {
            var $currTargetAbstractIcon = $currTarget.find('.js-abstract-toggle-icon');
            var toggleIconClass = $currTargetAbstractIcon.data('icon-class');
            var downArrow = `${toggleIconClass}-down`;
            var upArrow = `${toggleIconClass}-up`;

            $currTargetAbstractIcon.toggleClass(downArrow);
            $currTargetAbstractIcon.toggleClass(upArrow);

            if (!$abstractLocation.hasClass('hide')) {
                //get adobe analytics if its enabled and we're revealing the abstract (not closing it)
                if (window.digitalData) {
                    SCM.AdobeAnalytics.sendAdobeAnalyticsProductData(articleId);
                }
            }
        }
        function _toggleAbstractAria() {
            if ($abstractLocation.hasClass('hide')) {
                $abstractLocation.attr('aria-hidden', 'true');
            } else {
                $abstractLocation.attr('aria-hidden', 'false');
            }
        }

        function _toggleAriaExpanded() {
            $currTarget.attr('aria-expanded', $currTarget.attr('aria-expanded') === 'false' ? 'true' : 'false');
        }
    }

    function _getAbstractLocation(articleId, isLayAbstract) {
        if (isLayAbstract) {
            return $(`.js-layabstract#abstract-${articleId}`);
        } else {
            return $(`#abstract-${articleId}`);
        }
    }

    function _getAjaxUrl($linkContext, isLayAbstract) {
        var ajaxUrl = '';

        var baseSiteUrl = _getBaseSiteUrl();
        if (baseSiteUrl) {
            ajaxUrl += '//' + baseSiteUrl;
        }

        if (isLayAbstract) {
            ajaxUrl += '/PlatformArticle/ArticleLayAbstractAjax';
        } else if ($linkContext.data('abstract-type') === 'extract') {
            ajaxUrl += '/PlatformArticle/ArticleAbstractOrExtractAjax';
        } else {
            ajaxUrl += '/PlatformArticle/ArticleAbstractAjax';
        }

        return ajaxUrl;
    }

    function _getBaseSiteUrl() {
        var $field = $('#hfSiteURL');
        if (!$field.length) {
            return null;
        }

        return $field.val();
    }

    function _handleClickEventForTabs() {
        var $tabs = $('.js-tabs');
        var $container = $tabs.parents('.js-abstract-response-placeholder');
        $container.addClass('removePad');
        $(document).on('click', '.js-abstract-tab-link', function(e) {
            var $target = $(e.target);
            var $context = $target.closest('.js-abstract-response-placeholder');
            var $parent = $target.closest('.js-abstract-tab-link-wrap');
            var $content = $context.find('.js-tabs-content .js-abstract-tab-content-wrap');
            var tabNum = $parent.index();

            _switchTabLinks($context, $parent);
            _switchTabContent($content, tabNum);
        });
    }

    function _switchTabLinks($context, $clickedLink) {
        $context.find('.js-abstract-tab-link-wrap').removeClass('is-active');
        $clickedLink.addClass('is-active');
    }

    function _switchTabContent($content, tabNum) {
        $content.removeClass('is-active');
        $content.eq(tabNum).addClass('is-active');
    }

})(jQuery);
